
export default {
  name: 'FAQHome'
}
